import * as React from "react";
import { Create, type CreateProps } from "react-admin";
import { Box } from "@mui/material";
import { layout } from "./tokens";

type AppCreateProps = CreateProps & {
  aside?: React.ReactNode;
};

export function AppCreate({ children, aside, ...props }: AppCreateProps) {
  return (
    <Create
      {...props}
      aside={
        aside ? (
          <Box
            sx={{
              width: { xs: "100%", lg: layout.edit.asideWidth },
              maxWidth: "100%",
              mt: 0,
            }}
          >
            {aside}
          </Box>
        ) : undefined
      }
      sx={{
        "& .RaCreate-main": {
          pt: { xs: 5, sm: 5 },
          alignItems: "flex-start",
          justifyContent: { xs: "flex-start", lg: "center" },
          gap: layout.edit.gap,
        },
        "& .RaCreate-card": {
          width: { xs: "100%", lg: layout.edit.formWidth },
          maxWidth: "100%",
          flex: "0 0 auto",
          borderRadius: layout.card.radius,
          boxShadow: "none",
          backgroundImage: "none",
          border: "1px solid",
          borderColor: "divider",
        },
      }}
    >
      {children}
    </Create>
  );
}
